import {UmpireImage} from '../umpire-image';

export interface UmpireVenue {
  type: string;

  id: string;

  capacity: number | null;

  name: string;

  address: string;

  image: UmpireImage | null;

  relationshipNames: ['image'];
}
